

































































import {
  Component,
  Prop,
  Vue,
  Watch,
  Model,
  PropSync,
} from 'vue-property-decorator';
import { Extra, ExtraVariation } from '@/api';
import CurrencyField from '@/components/CurrencyField.vue';

@Component({
  components: { CurrencyField },
})
export default class extends Vue {
  @Model('input', { type: Array }) readonly value: Extra[];
  @PropSync('extrasPrices') pricesItems!: any;
  @Prop() readonly extraVariations: ExtraVariation[];
  @Prop({ default: false, type: Boolean }) readonly readonly: boolean;

  priceCosts: { [key: string]: string } = {};

  get selected() {
    if (!this.value) {
      return [];
    }
    return this.value.map((element: Extra) => element.id);
  }

  set selected(itemArray) {
    this.$emit(
      'input',
      this.items.filter((item: Extra) => itemArray.includes(item.id)),
    );
  }

  loading: boolean = false;

  items: Extra[] = [];

  extrasByType(type: string) {
    return this.items.filter(i => i.extraType === type);
  }

  updatePriceItems() {
    this.pricesItems = Object.keys(this.priceCosts).reduce(
      (a: { [key: string]: string }, b) => {
        if (this.selected.includes(b)) {
          a[b] = this.priceCosts[b];
        }
        return a;
      },
      {},
    );
  }

  getCost(item: Extra) {
    let price = '0.00';
    const variation = this.extraVariations.find(
      (e: ExtraVariation) => e.extra.id === item.id,
    );
    if (variation) {
      price = variation.price;
    }
    if (!variation || !price) {
      price = item.basePrice;
    }

    return price;
  }

  updateAllCosts() {
    this.items.map((item: Extra) => {
      if (!item.id) {
        return;
      }

      const price = this.getCost(item);
      this.priceCosts[item.id] = price;

      const currencyField = this.$refs[
        `extrasPrice${item.id}`
      ] as CurrencyField[];
      if (currencyField.length) {
        currencyField[0].setValue(price);
      }
      return item;
    }, {});
  }

  async update() {
    try {
      this.loading = true;
      const scope = Extra.includes([]);
      const result = await scope.all();
      this.items = result.data;

      this.priceCosts = this.items.reduce((a: { [key: string]: string }, b) => {
        if (!b.id) {
          return a;
        }

        let price = '0.00';
        if (this.pricesItems[b.id]) {
          price = this.pricesItems[b.id];
        } else {
          price = this.getCost(b);
        }
        a[b.id] = price;
        return a;
      }, {});
    } catch (e) {
      this.items = [];
    } finally {
      this.loading = false;
    }
  }

  mounted() {
    this.update();
  }

  @Watch('selected')
  @Watch('priceCosts', { deep: true })
  extrasChanged() {
    this.updatePriceItems();
  }
}
